import type {
  ButtonSize,
} from './types';

const LARGE: ButtonSize = 'large';
const DEFAULT: ButtonSize = 'default';
const SMALL: ButtonSize = 'small';

export const buttonSizes = {
  LARGE,
  DEFAULT,
  SMALL,
};
